<!--
   Created by qing on 2020/12/19
   Des: 附件、图片附件、备忘item详情
-->
<template>

  <van-popup
    class="node-item-detail-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    get-container="body"
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">
    <div class="node-item-detail-popup-content">
      <div v-if="loadingEnd" class="node-item-detail-container">

        <div class="item-header">
          <div class="title-info">
            <div class="title">
              {{itemDetail.name}}
            </div>
            <van-icon name="edit" @click="editItemInfo"/>
            <van-icon name="delete" class="delete-button" @click="deleteItemInfo"/>
          </div>
          <div class="info">
            <div>
              <van-image
                style="width: 16px; height: 16px"
                :src="itemInfo.itemImage"
                fit="cover">
              </van-image>
              {{itemTypeMap[itemInfo.itemType].name}}
            </div>
            <span>{{createUserName}}关联于{{actionFormatTime(itemInfo.createTime)}}</span>
          </div>
        </div>

        <div v-if="itemDetail.remark" class="remark ql-editor" v-html="itemDetail.remark">
        </div>

        <div class="file-container">

          <ul class="image__list" v-if="itemInfo.itemType === MIX_FORM_ITEM_TYPE_IMAGE">
            <li
              v-for="(img, idx) in itemInfo.itemDetail.fileList"
              class="image__list-item"
              :key="img.id">
              <template>
                <van-image
                  v-if="img.fileUrl"
                  width="60"
                  height="60"
                  @click="previewImage(idx)"
                  :src="img.fileUrl"
                  radius="6"
                  fit="cover">
                </van-image>
              </template>
            </li>
          </ul>

          <ul class="file__list" v-else>
            <li v-for="(file, idx) in itemDetail.fileList">
              <div class="file__icon">
                <svg class="icon" aria-hidden="true">
                  <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                </svg>
              </div>
              <div class="file__info">
                <div class="file__info-name">
                  {{file.fileName}}
                </div>
                <div class="file__info-bottom">

                  <div class="file__info-size">
                    {{file.fileSize}}KB
                  </div>
                  <div class="file__info-handle">
                    <div
                      class="handle-button"
                      @click.stop.prevent.left="previewFile(file)">
                      预览
                    </div>
                    <div class="divider"></div>
                    <div
                      class="handle-button"
                      @click.stop.prevent.left="downloadFile(file)">
                      下载
                    </div>
                    <div class="divider"></div>
                    <div
                      v-if="itemInfo.userId === $store.getters.userId"
                      class="handle-button"
                      @click="openFileAccessRecords(file.fileUrl)">
                      访问记录
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

        </div>

        <div style="margin-top: 10px; background-color: #fff">
          <comment-container
            ref="commentContainer"
            :commentList="commentList"
            :stackList="stackList"
            @replyComment="replyComment"
            @editComment="editComment"
            @onClickComment="onClickComment"
          ></comment-container>
        </div>
      </div>
      <div class="comment-input">
        <comment-input
          v-if="itemInfo"
          ref="commentInput"
          :nodeId="nodeId"
          :itemId="itemInfo.itemId"
          :mixFormId="mixFormId"
          commentType="ITEM"
          :fetchSourceContent="fetchSourceContent"
          @focusComment="focusComment"
          @submitCommentComplete="submitComment"
        ></comment-input>
      </div>

      <!--评论回复列表-->
      <CommentReplyList
        v-if="itemInfo"
        ref="commentReplyList"
        :nodeId="itemInfo.nodeId"
        :itemId="itemInfo.itemId"
        :mixFormId="mixFormId"
        :stackList="stackList"
        commentType="NODE"
        @reply-close="replyListClose"
      ></CommentReplyList>

      <!--item编辑-->
      <node-add-attach-popup
        ref="nodeAddAttachPopup"
        :stackList="stackList"
        :mixFormId="mixFormId"
        @updateItemComplete="updateItemComplete"
      ></node-add-attach-popup>

      <!--访问记录-->
      <file-access-records
        ref="fileAccessRecords"
        :stackList="stackList"
      ></file-access-records>

      <file-preview-popup
        ref="filePreviewPopup"
        :stackList="stackList"
      ></file-preview-popup>
    </div>

  </van-popup>
</template>

<script>
  import {accurateFormatDate, fileType2FileImage, getSimpleText, clone} from "../../../assets/js/Untis";
  import CommentContainer from "./CommentContainer";
  import CommentInput from "./CommentInput";
  import CommentReplyList from "./CommentReplyList";
  import NodeAddAttachPopup from "./NodeAddAttachPopup";
  import FileAccessRecords from "./FileAccessRecords";
  import {
    MIX_FORM_ITEM_TYPE_ATTACHMENT,
    MIX_FORM_ITEM_TYPE_IMAGE,
    MIX_FORM_ITEM_TYPE_MEMO,
    MIX_FORM_ITEM_TYPE_APPLY,
    MIX_FORM_ITEM_TYPE_DATA,
    MIX_FORM_ITEM_TYPE_VIEW,
    MIX_FORM_ITEM_TYPE_DASHBOARD
  } from "../../store/types";
  import {ImagePreview} from 'vant'
  import FilePreviewPopup from "./FilePreviewPopup";

  export default {
    props: {
      titleInfo: Object,
      mixFormId: {
        type: String,
        default: ''
      },
      mixFormInfo: Object,
      stackList: {
        type: Array,
        default: () => []
      }
    },
    components: {
      CommentContainer,
      CommentInput,
      CommentReplyList,
      NodeAddAttachPopup,
      FileAccessRecords,
      FilePreviewPopup
    },
    data() {
      return {
        MIX_FORM_ITEM_TYPE_IMAGE,
        visibleInfo: {
          nodeId: '',
          visible: false
        },
        loadingEnd: false,
        nodeId: '',
        itemInfo: null,
        itemDetail: null,
        downloadEle: null,
        commentList: [],

        itemTypeMap: {
          [MIX_FORM_ITEM_TYPE_ATTACHMENT]: {
            name: '附件',
            icon: ''
          },
          [MIX_FORM_ITEM_TYPE_IMAGE]: {
            name: '图片附件',
            icon: ''
          },
          [MIX_FORM_ITEM_TYPE_MEMO]: {
            name: '备忘录',
            icon: ''
          },
          [MIX_FORM_ITEM_TYPE_APPLY]: {
            name: '发起表单',
            icon: ''
          },
          [MIX_FORM_ITEM_TYPE_DATA]: {
            name: '表单数据',
            icon: ''
          },
          [MIX_FORM_ITEM_TYPE_VIEW]: {
            name: '表单视图',
            icon: ''
          },
          [MIX_FORM_ITEM_TYPE_DASHBOARD]: {
            name: '仪表盘',
            icon: ''
          }
        },
      }
    },
    created() {
      this.downloadEle = document.createElement('a')
      this.downloadEle.setAttribute('target', '_blank')
    },
    computed: {
      createUserName() {
        const user = this.$store.getters.userListMap[this.itemInfo.userId]
        const extUser = this.$store.getters.extMap[this.itemInfo.userId]
        return user ? user.nickname : extUser ? extUser.orgUserName : ''
      },
    },
    methods: {
      actionFormatTime(d) {
        return accurateFormatDate(d)
      },
      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },
      open({nodeId, itemId}) {
        this.loadingEnd = false
        this.nodeId = nodeId
        this.visibleInfo.nodeId = nodeId
        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true


        this.$store.dispatch('actionMixFormNodeItemDetail', {
          mixFormId: this.$route.params.mixFormId,
          nodeId: nodeId,
          itemId: itemId
        }).then(res => {
          this.itemInfo = res
          this.itemDetail = this.itemInfo.itemDetail
          this.titleInfo.title = this.itemDetail.name

          this.fetchCommentList()
        }).catch(console.error)
          .finally(() => {
            this.loadingEnd = true
          })
      },

      beforeClose() {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.close()
        }
        if (this.$refs.commentReplyList) {
          this.$refs.commentReplyList.close()
        }
        this.$emit('close')
      },
      fetchCommentList() {
        this.$store.dispatch('actionCommentList', {
          mixFormId: this.mixFormId,
          nodeId: this.nodeId,
          itemId: this.itemInfo.itemId,
          commentType: 'ITEM'
        }).then(res => {
          this.commentList = res
        }).catch(console.error)
      },

      // 下载文件
      downloadFile(file) {
        this.downloadEle.setAttribute('download', file.fileName)
        this.downloadEle.setAttribute('href', `${file.fileUrl}?userId=${this.$store.state.userInfo.userId}`)
        this.downloadEle.click()
      },
      previewFile(file) {

        if (this.$refs.filePreviewPopup) {
          this.$refs.filePreviewPopup.open(file, 'MIX_FORM')
        }

      },

      // 预览图片
      previewImage(idx) {
        // if (window.isLark) {
        //   console.log('urls', this.current.value.map(item => item.imgUrl))
        //   console.log('current', this.current.value.map(item => item.imgUrl)[idx])
        //   this.$tt.ready(() => {
        //
        //     const urls = this.current.value.map(item => item.imgUrl)
        //     this.$tt.biz.util.previewImage({
        //       urls,
        //       current: urls[idx]
        //     });
        //
        //   })
        //
        // } else {
        ImagePreview({
          images: this.itemInfo.itemDetail.fileList.map(item => item.fileUrl),
          startPosition: idx
        })
        // }
      },

      // 编辑item
      editItemInfo() {
        if (this.mixFormInfo.archived) {
          this.$toast.fail(`该${this.$store.getters.mix_form_name}已归档，暂时无法操作，请启用后操作`)
          return
        }
        if (this.$refs.nodeAddAttachPopup) {
          this.$refs.nodeAddAttachPopup.open(this.itemInfo)
        }
      },
      // 删除item
      deleteItemInfo() {
        if (this.mixFormInfo.archived) {
          this.$toast.fail(`该${this.$store.getters.mix_form_name}已归档，暂时无法操作，请启用后操作`)
          return
        }
        this.$dialog.confirm({
          title:'提示',
          message: '将会删除关联入口，但不会删除数据。是否删除？',
          confirmButtonText: '删除',
          cancelButtonText: '取消'
        }).then(() => {
          this.$store.dispatch('actionMixFormNodeItemDelete', {
            mixFormId: this.mixFormId,
            nodeId: this.nodeId,
            itemId: this.itemInfo.itemId,
          }).then(res => {
            this.$toast.success('删除成功')
            this.$emit('deleteNodeItemComplete', this.itemInfo.itemId)
            const visibleInfo = this.stackList.pop()
            visibleInfo.visible = false
          }).catch(console.error)

        }).catch(action => {
        })
      },
      // 更新item完成
      updateItemComplete(itemInfo) {
        Object.keys(itemInfo).forEach(key => {
          if (this.itemInfo.hasOwnProperty(key)) {
            this.itemInfo[key] = itemInfo[key]
          }
        })
        this.itemDetail = this.itemInfo.itemDetail
        this.$emit('updateItemComplete', itemInfo)
      },

      // 获取回复的评论
      fetchSourceComment(commentId) {
        return this.commentList.filter(comment => comment.commentId === commentId)[0]
      },
      // 获取回复的评论的字符串内容
      fetchSourceContent(commentId) {
        const comment = this.fetchSourceComment(commentId)
        if (!comment) {
          return ''
        }
        let content = getSimpleText(comment.content)
        content += comment.content.includes('<img') ? '【图片】' : ''
        content += comment.content.includes('<video') ? '【视频】' : ''
        if (!content) {
          if (comment.attachmentList && comment.attachmentList.length) {
            content = '【附件】'
          }
        }
        return content
      },

      // 首次填写评论
      focusComment() {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'NONE'
          })
        }
      },

      // 回复评论
      replyComment(item) {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'REPLY',
            replyCommentInfo: item
          })
        }
      },
      // 编辑评论
      editComment(item) {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'EDIT',
            commentInfo: clone(item)
          })
        }
      },
      // 点击评论
      onClickComment(item) {
        if (item.replyId && this.$refs.commentReplyList) {
          this.$refs.commentReplyList.open({
            commentId: item.commentId,
            rootId: item.rootId
          })
        }
      },
      // 发表评论完成
      submitComment({commentStatus, commentInfo}) {
        if (commentStatus === 'EDIT') {
          const comment = this.commentList.filter(comment => comment.commentId === commentInfo.commentId)[0]
          if (comment) {
            comment.content = commentInfo.content
            comment.attachmentList = commentInfo.attachmentList
          }
        } else {
          this.commentList.unshift(commentInfo)
        }
      },

      // 回复列表关闭，需要刷新一下评论列表
      replyListClose() {
        this.fetchCommentList()
      },

      openFileAccessRecords(fileUrl) {
        if (this.$refs.fileAccessRecords) {
          this.$refs.fileAccessRecords.open(fileUrl)
        }
      },
    }
  }
</script>

<style lang="less">

  .node-item-detail-popup {
    background-color: #F6F6F6 !important;

    .node-item-detail-popup-content {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;

      .node-item-detail-container {
        position: absolute;
        top: 0;
        bottom: calc(50px + env(safe-area-inset-bottom));
        left: 0;
        right: 0;
        overflow: auto;

        .file-container {
          background-color: #fff;
          border-bottom: 1px solid #e6e6e6;
          padding: 0 20px;

          .image__list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            padding: 10px 0;

            > .image__list-item {
              width: 60px;
              height: 60px;
              margin-right: 8px;
              margin-bottom: 8px;
              border-radius: 6px;
              position: relative;
            }
          }
        }

        .item-header {
          width: 100%;
          height: 80px;
          padding: 20px;
          background-color: #fff;
          border-bottom: 1px solid #e6e6e6;

          .title-info {
            display: flex;
            margin-bottom: 15px;

            .title {
              max-width: calc(100% - 40px);
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-wrap: break-word;
              margin-right: 10px;
            }

            .delete-button {
              color: red;
              margin-left: 10px;
            }
          }
          > .info {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #959699;

            > div {
              display: flex;
              align-items: center;
              color: #6d6d6d;
              margin-right: 20px;

              .van-image {
                margin-right: 5px;
              }
            }
          }
        }

        .remark {
          overflow: hidden;
          height: fit-content;
          width: 100%;
          padding: 10px;
          font-size: 12px;
          color: #333;


          img, video {
            max-width: 100%;
          }
        }
      }

      .comment-input {
        position: absolute;
        height: 50px;
        bottom: calc(env(safe-area-inset-bottom));
        left: 0;
        right: 0;
      }
    }

    .handle-button {
      font-size: 12px;
      color: #2D8cF0;
    }


    .file__list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      list-style: none;
      margin: 0;
      padding: 0;

      > li {
        list-style: none;
        width: calc(100% - 10px);
        min-height: 40px;
        margin: 5px;
        display: flex;
        position: relative;
        border-bottom: 1px solid #e6e6e6;


        > .file__icon {
          text-align: center;

          .icon {
            width: 30px;
            height: 30px;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
            margin-right: 10px;
            margin-top: 5px;
          }
        }

        > .file__info {
          width: calc(100% - 40px);
          display: flex;
          flex-direction: column;

          > .file__info-name {
            line-height: 20px;
            color: #495060;
            font-size: 13px;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;
          }

          > .file__info-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;

            > .file__info-size {
              height: 20px;
              line-height: 20px;
              font-size: 11px;
              color: #909399;
            }

            > .file__info-handle {
              display: flex;
              align-items: center;

              .divider {
                height: 16px;
                width: 1px;
                background-color: #e6e6e6;
                margin: 0 5px;
              }
            }
          }
        }
      }
    }
  }
</style>